module.exports = __webpack_public_path__ + "117b8eec0f3e9b90de1cb3275eebe7b8.svg";